
























import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import IconButton from '@/components/button/IconButton.vue';

@Component({
  components: {IconButton},
  mixins: [InputMixin]
})
export default class FileInput extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: ''}) protected readonly value: any;
  @Prop({default: ''}) protected readonly originValue: any;
  @Prop({default: null}) private readonly acceptPattern: string;
  @Prop({default: false}) protected readonly loading: boolean;
  @Prop({default: false}) protected readonly restoreable: boolean;

  private deleted: boolean = false;

  get accept() {
    return this.acceptPattern;
  }

  get isLoading() {
    return this.loading;
  }

  get isEditable() {
    return !this.isReadOnly && !this.isDisabled;
  }

  get isDeleteVisible() {
    return this.isEditable && !this.deleted && this.value;
  }

  get isRestoreVisible() {
    return this.restoreable && this.isEditable &&
        this.deleted && this.originValue && (this.value !== this.originValue);
  }

  public onChange(file: any, fileList: any[]) {
    this.commitValue(file.name, file.raw);
  }

  public onExceed(files: File[], fileList: any[]) {
    this.commitValue(files[0].name, files[0]);
  }

  public onRemove(event: any) {
    event.stopPropagation();
    this.commitValue('', undefined);
    this.deleted = true;
  }

  public onRestore(event: any) {
    event.stopPropagation();
    this.$emit('restore');
    if (this.changeDetectable) {
      this.$store.commit('commitValue', {
        itemId: this.getId,
        value: this.originValue,
        originValue: this.originValue
      });
    }
    this.deleted = false;
  }

  public commitValue(fileName: string, raw: File | undefined) {
    this.$emit('input', fileName);
    this.$emit('fileChange', raw);
    this.deleted = false;

    if (this.changeDetectable) {
      this.$store.commit('commitValue', {
        itemId: this.getId,
        value: fileName,
        originValue: this.originValue
      });
    }
  }

}
